import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import {
  selectCreateNewAccountModal,
  selectForgottenPasswordModal,
  setCreateNewAccountModal,
  setForgottenPasswordModal,
} from "slices/signInPageSlice";
import SignInForm from "./SignIn/SignInForm";
import ForgotPasswordForm from "./ForgotPassword/ForgotPasswordForm";
import CreateNewAccountForm from "./CreateNewAccount/CreateNewAccountForm";
import ColourBorder from "../General-UI/ColourBorder";
import Modal from "../HOCS/Modal";
import { selectCurrentUser } from "slices/authSlice";
import FullLogoLarge from "graphics/Branding/FullLogoLarge.svg";
import history from "constants/history";

const SignInPage = (props) => {
  const dispatch = useDispatch();
  const createNewAccountModal = useSelector(selectCreateNewAccountModal);
  const forgottenPasswordModal = useSelector(selectForgottenPasswordModal);
  const currentUser = useSelector(selectCurrentUser);
  // if there is a current user, it means they need to go to sign In page,
  // if not it means they jumped straigt into the app with this route (possibly by a bookmark), in which we should send them to home page which will check for auth and redirect if necessary
  if (currentUser === null) {
    return (
      <div className="signInComponent">
        <ColourBorder />
        <div className="whiteContainer signInBackground">
          {createNewAccountModal ? (
            <Modal
              onDismiss={() => {
                dispatch(setCreateNewAccountModal(false));
              }}
              lightBackDrop={true}
              growth={true}
              header={<div>Sign Up</div>}
              content={
                <CreateNewAccountForm
                  postCreate={() => history.push("/home")}
                />
              }
              actions={null}
              noBackDropClick={true}
              containerClass={"signInUpFormBox"}
            ></Modal>
          ) : null}
          {forgottenPasswordModal ? (
            <Modal
              onDismiss={() => {
                dispatch(setForgottenPasswordModal(false));
              }}
              lightBackDrop={true}
              growth={false}
              header={<div>Password Reset</div>}
              content={
                <ForgotPasswordForm postSignIn={() => history.push("/home")} />
              }
              actions={null}
              noBackDropClick={true}
              containerClass={"signInUpFormBox"}
            ></Modal>
          ) : null}
          <div className="row nice-centre-row signIn">
            <div className="col-lg-6 col-sm-12 text-center">
              <img alt="logo" src={FullLogoLarge} className="full-logo" />
            </div>
            <div className="col-lg-6 col-sm-12">
              <button
                onClick={() => {
                  dispatch(setCreateNewAccountModal(true));
                }}
                className="confirm-button growth-button mt-1 new-account-button form-shadow"
              >
                Make An Account
              </button>
              <div className="signInUpFormBox form-shadow">
                <SignInForm postSignIn={() => history.push("/home")} />
                <button
                  onClick={() => {
                    dispatch(setForgottenPasswordModal(true));
                  }}
                  className="forgotten-password"
                >
                  forgot password?
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <>
        {window.efs_debug && window.log("Sign In Page: ")}
        {window.efs_debug && window.log(JSON.stringify(currentUser), 2)}
        <Redirect to={{ pathname: "/", state: { from: props.location } }} />
      </>
    );
  }
};

export default SignInPage;
